const preselectedEquipment = [
    {
        productId: 0,
        preselectedEquipment: [
            {
                equipmentId: 0,
                selectedOptions: []
            },
            {
                equipmentId: 1,
                selectedOptions: []
            },
            {
                equipmentId: 2,
                selectedOptions: []
            },
            {
                equipmentId: 3,
                selectedOptions: []
            },
            {
                equipmentId: 4,
                selectedOptions: []
            },
            {
                equipmentId: 5,
                selectedOptions: []
            },
            {
                equipmentId: 6,
                selectedOptions: []
            },
            {
                equipmentId: 7,
                selectedOptions: []
            },
        ]
    },
    {
        productId: 1,
        preselectedEquipment: [
            {
                equipmentId: 0,
                selectedOptions:[
                    { 
                        optionId: 1,
                        quantity: 10,
                        usage: 5 // hour
                    }
                ]
            },
            {
                equipmentId: 1,
                selectedOptions: [
                    { 
                        optionId: 0,
                        quantity: 4,
                        usage: 2
                    },
                    { 
                        optionId: 2,
                        quantity: 1,
                        usage: 2
                    }
                ]
            },
            {
                equipmentId: 2,
                selectedOptions: [
                    { 
                        optionId: 0,
                        quantity: 1,
                        usage: 6
                    }
                ]
            },
            {
                equipmentId: 3,
                selectedOptions: [
                    { 
                        optionId: 1,
                        quantity: 1,
                        usage: 1
                    }
                ]
            },
            {
                equipmentId: 4,
                selectedOptions: []
            },
            {
                equipmentId: 5,
                selectedOptions: []
            },
            {
                equipmentId: 6,
                selectedOptions: []
            },
            {
                equipmentId: 7,
                selectedOptions: []
            },
        ]
    },
    {
        productId: 2,
        preselectedEquipment: [
            {
                equipmentId: 0,
                selectedOptions:[
                    { 
                        optionId: 2,
                        quantity: 10,
                        usage: 5 // hour
                    }
                ]
            },
            {
                equipmentId: 1,
                selectedOptions: [
                    { 
                        optionId: 0,
                        quantity: 4,
                        usage: 2
                    },
                    { 
                        optionId: 2,
                        quantity: 1,
                        usage: 4
                    }
                ]
            },
            {
                equipmentId: 2,
                selectedOptions: [
                    { 
                        optionId: 0,
                        quantity: 1,
                        usage: 6
                    }
                ]
            },
            {
                equipmentId: 3,
                selectedOptions: [
                    { 
                        optionId: 3,
                        quantity: 1,
                        usage: 1
                    }
                ]
            },
            {
                equipmentId: 4,
                selectedOptions: []
            },
            {
                equipmentId: 5,
                selectedOptions: []
            },
            {
                equipmentId: 6,
                selectedOptions: []
            },
            {
                equipmentId: 7,
                selectedOptions: []
            },
        ]
    },
    {
        productId: 3,
        preselectedEquipment: [
            {
                equipmentId: 0,
                selectedOptions: []
            },
            {
                equipmentId: 1,
                selectedOptions: []
            },
            {
                equipmentId: 2,
                selectedOptions: []
            },
            {
                equipmentId: 3,
                selectedOptions: []
            },
            {
                equipmentId: 4,
                selectedOptions: []
            },
            {
                equipmentId: 5,
                selectedOptions: []
            },
            {
                equipmentId: 6,
                selectedOptions: []
            },
            {
                equipmentId: 7,
                selectedOptions: []
            },
        ]
    },
    {
        productId: 4,
        preselectedEquipment: [
            {
                equipmentId: 0,
                selectedOptions:[
                    { 
                        optionId: 2,
                        quantity: 20,
                        usage: 5 // hour
                    }
                ]
            },
            {
                equipmentId: 1,
                selectedOptions: [
                    { 
                        optionId: 0,
                        quantity: 4,
                        usage: 2
                    },
                    { 
                        optionId: 2,
                        quantity: 1,
                        usage: 4
                    }
                ]
            },
            {
                equipmentId: 2,
                selectedOptions: [
                    { 
                        optionId: 1,
                        quantity: 1,
                        usage: 6
                    }
                ]
            },
            {
                equipmentId: 3,
                selectedOptions: [
                    { 
                        optionId: 3,
                        quantity: 1,
                        usage: 1
                    }
                ]
            },
            {
                equipmentId: 4,
                selectedOptions: [
                    { 
                        optionId: 0,
                        quantity: 1,
                        usage: 0.5
                    }
                ]
            },
            {
                equipmentId: 5,
                selectedOptions: [
                    { 
                        optionId: 4,
                        quantity: 1,
                        usage: 0.16
                    }
                ]
            },
            {
                equipmentId: 6,
                selectedOptions: [
                    { 
                        optionId: 1,
                        quantity: 1,
                        usage: 2
                    }
                ]
            },
            {
                equipmentId: 7,
                selectedOptions: []
            },
        ]
    },
    {
        productId: 5,
        preselectedEquipment: [
            {
                equipmentId: 0,
                selectedOptions: []
            },
            {
                equipmentId: 1,
                selectedOptions: []
            },
            {
                equipmentId: 2,
                selectedOptions: []
            },
            {
                equipmentId: 3,
                selectedOptions: []
            },
            {
                equipmentId: 4,
                selectedOptions: []
            },
            {
                equipmentId: 5,
                selectedOptions: []
            },
            {
                equipmentId: 6,
                selectedOptions: []
            },
            {
                equipmentId: 7,
                selectedOptions: []
            },
        ]
    },
    {
        productId: 6,
        preselectedEquipment: [
            {
                equipmentId: 0,
                selectedOptions: []
            },
            {
                equipmentId: 1,
                selectedOptions: []
            },
            {
                equipmentId: 2,
                selectedOptions: []
            },
            {
                equipmentId: 3,
                selectedOptions: []
            },
            {
                equipmentId: 4,
                selectedOptions: []
            },
            {
                equipmentId: 5,
                selectedOptions: []
            },
            {
                equipmentId: 6,
                selectedOptions: []
            },
            {
                equipmentId: 7,
                selectedOptions: []
            },
        ]
    },
    {
        productId: 7,
        preselectedEquipment: [
            {
                equipmentId: 0, // Éclairage
                selectedOptions: [
                    { 
                        optionId: 3,  // Ampoules / Spot LED 10W
                        quantity: 30,
                        usage: 6
                    }
                ]
            },
            {
                equipmentId: 1, // Téléphonie & PC
                selectedOptions: [
                    { 
                        optionId: 2,  // PC PORTABLE 50W
                        quantity: 2,
                        usage: 6
                    },
                    { 
                        optionId: 0,  // Chargeur Smartphone 5W
                        quantity: 4,
                        usage: 4
                    }
                ]
            },
            {
                equipmentId: 2, // Son & Image
                selectedOptions: [
                    { 
                        optionId: 1,  // TV LED ECRAN PLAT 100W
                        quantity: 1,
                        usage: 10
                    }
                ]
            },
            {
                equipmentId: 3, // Électroménager
                selectedOptions: [
                    { 
                        optionId: 4,  // FRIGO AMÉRICAIN A+ 24H/Jour: 1800WH
                        quantity: 1,
                        usage: 1
                    }
                ]
            },
            {
                equipmentId: 4, // Petit Électroménager
                selectedOptions: [
                    { 
                        optionId: 0,  // Robot cuisine 500W
                        quantity: 1,
                        usage: 1
                    }
                ]
            },
            {
                equipmentId: 5, // Gros Électroménager
                selectedOptions: [
                    { 
                        optionId: 4,  // Cafetière / Bouilloire 1500W
                        quantity: 1,
                        usage: 0.25  // 15 minutes
                    },
                    { 
                        optionId: 4,  // Cafetière / Bouilloire 1500W
                        quantity: 1,
                        usage: 0.5   // 30 minutes
                    },
                    { 
                        optionId: 0,  // Machine à laver hublot 2000W
                        quantity: 1,
                        usage: 0.5   // 30 minutes
                    }
                ]
            },
            {
                equipmentId: 6, // Pompage
                selectedOptions: [
                    { 
                        optionId: 1,  // Pompe 220V 600W
                        quantity: 1,
                        usage: 2
                    }
                ]
            },
            {
                equipmentId: 7, // Sécurité
                selectedOptions: []
            },
            {
                equipmentId: 8, // Personnalisé
                selectedOptions: [
                    { 
                        optionId: 5,  // Puissance 800W
                        quantity: 1,
                        usage: 0.25  // 15 minutes
                    }
                ]
            }
        ]
    },
    {
        productId: 8,
        preselectedEquipment: [
            {
                equipmentId: 0,
                selectedOptions: []
            },
            {
                equipmentId: 1,
                selectedOptions: []
            },
            {
                equipmentId: 2,
                selectedOptions: []
            },
            {
                equipmentId: 3,
                selectedOptions: []
            },
            {
                equipmentId: 4,
                selectedOptions: []
            },
            {
                equipmentId: 5,
                selectedOptions: []
            },
            {
                equipmentId: 6,
                selectedOptions: []
            },
            {
                equipmentId: 7,
                selectedOptions: []
            },
        ]
    },
    {
        productId: 9,
        preselectedEquipment: [
            {
                equipmentId: 0,
                selectedOptions: []
            },
            {
                equipmentId: 1,
                selectedOptions: []
            },
            {
                equipmentId: 2,
                selectedOptions: []
            },
            {
                equipmentId: 3,
                selectedOptions: []
            },
            {
                equipmentId: 4,
                selectedOptions: []
            },
            {
                equipmentId: 5,
                selectedOptions: []
            },
            {
                equipmentId: 6,
                selectedOptions: []
            },
            {
                equipmentId: 7,
                selectedOptions: []
            },
        ]
    },
];

export default preselectedEquipment;